var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 908,
    height: 47,
    viewBox: "0 0 908 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_2382_10117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 26C110 23.2386 112.239 21 115 21H793C795.761 21 798 23.2386 798 26H110Z",
    fill: "url(#paint0_radial_2382_10117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 26C110 23.2386 112.239 21 115 21H793C795.761 21 798 23.2386 798 26H110Z",
    stroke: "url(#paint1_linear_2382_10117)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.3333C0 23.4128 0.746192 22.6667 1.66667 22.6667H906.333C907.254 22.6667 908 23.4128 908 24.3333H0Z",
    fill: "url(#paint2_radial_2382_10117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2382_10117",
    x: 89.5,
    y: 0.5,
    width: 729,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_2382_10117"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2382_10117",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(802.547 24.3334) rotate(180) scale(695.577 1055.94)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121831",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507687,
    stopColor: "#4390EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121831",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2382_10117",
    x1: 91.6404,
    y1: 21,
    x2: 797.997,
    y2: 22.4556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0747648,
    stopColor: "#C977D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#602EA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2382_10117",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(914 23.7778) rotate(180) scale(918 351.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121831",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507687,
    stopColor: "#4390EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121831",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/Separator.0db0b8762536acbc361eb340770b5322.svg";
export { ForwardRef as ReactComponent };